import type { Permissions } from '../types';

export default function containsPermission(permission?: Permissions, permissions?: Permissions[]): boolean {
  return !!permission && !!permissions?.includes(permission);
}
